// ABOUTME: Transformation schema mapping Rusada deferred defect fields to TechLog defect deferral update.
import type { RusadaToTechlogDefectDeferInput } from './validation';

export const rusadaDefectDeferToTechlogSchema = {
  deferred: () => true as const,

  rectificationCategory: (input: RusadaToTechlogDefectDeferInput) => {
    const melCat = input.rusada.melCategories.find(
      (cat) => cat.id === input.rusada.defect.melPriorityId,
    );
    if (!melCat) {
      throw new Error(
        `No MEL category found for melPriorityId ${input.rusada.defect.melPriorityId}`,
      );
    }

    const melPriorityToRectification: Record<string, string> = {
      'MEL A': 'A',
      'MEL B': 'B',
      'MEL C': 'C',
      'MEL D': 'D',
      'NO MEL': 'NONDEFERRED',
      HUSB: 'ADVISORYONLY',
    };
    const category = melPriorityToRectification[melCat.melPriority];
    if (!category) {
      throw new Error(
        `Unknown MEL priority '${melCat.melPriority}' for melPriorityId ${input.rusada.defect.melPriorityId}`,
      );
    }
    return category;
  },

  reasonToDefer: (input: RusadaToTechlogDefectDeferInput) =>
    input.rusada.defect.actionText || 'Deferred in Veryon Tracking+',

  deferApprovalReference: (input: RusadaToTechlogDefectDeferInput) =>
    input.rusada.defect.addReference || undefined,

  limitations: () => undefined,
  limitFlightSeconds: () => undefined,
  limitCycles: () => undefined,

  // TechLog adds limitCalendarDays to raisedAt to calculate dueDate
  limitCalendarDays: (input: RusadaToTechlogDefectDeferInput) => {
    const raised = new Date(input.techlog.defect.raisedAt);

    if (input.rusada.defect.targetDate) {
      const diffMs =
        new Date(input.rusada.defect.targetDate).getTime() - raised.getTime();
      const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
      return diffDays > 0 ? diffDays : undefined;
    }

    const melCat = input.rusada.melCategories.find(
      (cat) => cat.id === input.rusada.defect.melPriorityId,
    );
    return melCat?.days;
  },
};

export default rusadaDefectDeferToTechlogSchema;
